module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-6.a0caeb4e.jpg";